import { Background, Container, ContentArea, SidebarMenu } from '@/components/wm';
import * as React from 'react';
import { useState } from 'react';
import { Language } from './Language';
import { Notifications } from './Notifications';
import { Password } from './Password';
import { Profile } from './Profile';

export default function UserProfile() {
    const [currentView, setCurrentView] = useState('profile'); // Profile, Password, Preferences

    const menuItems = [
        {
            key: 'profile',
            title: i18next.t('common.details').capitalize(),
            icon: 'user'
        },
        {
            key: 'password',
            title: i18next.t('common.password').capitalize(),
            icon: 'password'
        },
        {
            key: 'notifications',
            title: i18next.t('common.notifications').capitalize(),
            icon: 'notifications'
        },
        {
            key: 'language',
            title: i18next.t('common.language').capitalize(),
            icon: 'globe'
        }
    ];

    const handleViewChange = view => {
        setCurrentView(view);
    };

    return (
        <Background>
            <Container variant="full">
                <SidebarMenu
                    currentView={currentView}
                    handleViewChange={handleViewChange}
                    items={menuItems}
                />
                <ContentArea>
                    {currentView === 'profile' && (
                        <Profile/>
                    )}
                    {currentView === 'password' && (
                        <Password/>
                    )}
                    {currentView === 'notifications' && (
                        <Notifications/>
                    )}
                    {currentView === 'language' && (
                        <Language/>
                    )}
                </ContentArea>
            </Container>
        </Background>
    );
}
